<template>
  <v-container fluid>
    <v-snackbar top v-model="alert.show" multi-line :color="alert.type">
        {{ alert.msg }}
        <v-btn text @click="alert.show = false">
          Close
        </v-btn>
      </v-snackbar>
    <!-- <h2 class="mb-3">Logout Berhasil</h2> -->
  </v-container>
</template>

<script>
export default {
  name: "logout",
  data() {
    return {
      alert: {
        show: false,
        msg: '',
        type: '',
      }
    }
  },
  methods: {
    showMessage(msg, type) {
      this.alert.msg = msg
      this.alert.type = type
      this.alert.show = true
    }
  },
  created() {
    localStorage.clear()
    this.showMessage(this.$i18n.t('logout_alert'))
    setTimeout(() => {
      this.$router.push({ name: "login" })
    }, 3000);
  },
  components: {}
};
</script>
